import { useState } from 'react';
import { Text } from 'braid-design-system';
import { Turnstile } from 'react-turnstile';
import { useEnvironmentConfig } from '#src/hooks/environment.tsx';
import { useDatadog } from '../Datadog/Datadog.tsx';

interface TurnstileWidgetProps {
  onTurnstileValidate: (token: string) => void;
  missingTokenError: boolean;
}

export const TurnstileWidget = ({
  onTurnstileValidate,
  missingTokenError,
}: TurnstileWidgetProps) => {
  const { siteKey } = useEnvironmentConfig();
  const [error, setError] = useState<string | null>(null);
  const datadog = useDatadog();

  const handleVerify = async (token: string | undefined) => {
    if (token) {
      setError(null);
      onTurnstileValidate(token);
    }
  };

  return (
    <>
      <Turnstile
        sitekey={siteKey}
        onVerify={handleVerify}
        onError={(turnstileError) => {
          const message = 'An error occurred while loading Turnstile.';

          datadog.addError(turnstileError, {
            turnstileError,
            msg: message,
          });

          if (!missingTokenError) {
            setError(message);
          }
        }}
        refreshExpired="auto"
      />
      {!missingTokenError && error && (
        <Text tone="critical" size="xsmall">
          {error}
        </Text>
      )}
    </>
  );
};
